import type { IHeaderText } from "app/components/sharingAssetModal/types";
import type { FC } from "react";
import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";
import { Title } from "app/components/sharingAssetModal/components/Styled";

const { carbon } = colorsPalettes;
const { setFontVariant } = mixins;
const Container = styled.div`
    border-bottom: 1px solid ${carbon[100]};
    padding: 20px 24px 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 54px;
`;

const Subtitle = styled.div`
    ${setFontVariant("body1", carbon[400])}
`;

export const Header: FC<IHeaderText> = (props) => {
    const { title, subtitle } = props;
    return (
        <Container>
            <Title>{title}</Title>
            {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
        </Container>
    );
};
